// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bz4o","delete":"styles_delete__3y5sh","update":"styles_update__A2-2E","add":"styles_add__2FlfA"};